// @flow
import React, { useEffect } from 'react';
import { View, StyleSheet } from 'react-native';
import { Text } from 'trpc-react-native-ui';
import I18n from '../../../../../lib/i18n';
import { HyperText } from '../../../../../components/common';
import theme from '../../../../../theme-config';
import config from '../../../../../config';
import type { AgreementSpecification } from 'digicel-kaizen-library';

const styles = StyleSheet.create({
  baseText: {
    textAlign: 'justify',
    marginHorizontal: 20,
    lineHeight: 14,
    fontSize: 12,
    fontFamily: theme.fontFamily,
    paddingVertical: 5,
  },
  text: {
    color: theme.legalBlurb.textColor,
    fontWeight: '200',
  },
  hyperText: {
    color: theme.legalBlurb.textColor,
  },
});

export const LegalBlurb = ({ agreement, fetchAgreementsByProductOfferings }: Props) => {
  useEffect(() => {
    if (!agreement) {
      fetchAgreementsByProductOfferings();
    }
  }, []);

  const pricingConditionsAttachment = agreement?.agreementAttachments?.find(
    attachment => attachment.type === config.AGREEMENT_TYPES.PRICING_CONDITIONS
  );

  const url =
    pricingConditionsAttachment && config.STATIC_FILE_URL.replace('{fileName}', pricingConditionsAttachment.id);

  return (
    <View>
      <Text style={styles.baseText}>
        <Text style={styles.text}>{I18n.t('legalBlurb.part1')}</Text>
        {!!url && (
          <HyperText url={url} style={styles.hyperText}>
            {I18n.t('legalBlurb.hyperText')}
          </HyperText>
        )}
      </Text>
    </View>
  );
};

type Props = StateProps & DispatchProps;

export type StateProps = {
  agreement: ?AgreementSpecification,
};

export type DispatchProps = {
  fetchAgreementsByProductOfferings: Function,
};
